import { Component, OnInit } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatDialog } from '@angular/material/dialog'
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { ReservationScheduleService } from '../../../core/services/purchase-reservation/reservation-schedule/reservation-schedule.service'
import { SearchReservationTgModel } from '../../../core/models/purchase-reservation.model'
import { FormSearchPurchaseReservationTgComponent } from '../../../shared/components/form-search-purchase-reservation-tg/form-search-purchase-reservation-tg.component'
import { TableListPurchaseReservationTgComponent } from '../../../shared/components/table-list-purchase-reservation-tg/table-list-purchase-reservation-tg.component'
import { PurchaseReservationTgViewComponent } from '../purchase-reservation-tg-view/purchase-reservation-tg-view.component'

@Component({
  selector: 'purchase-reservation-tg',
  imports: [
    MatProgressBar,
    MatPaginatorModule,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    FormSearchPurchaseReservationTgComponent,
    TableListPurchaseReservationTgComponent,
  ],
  templateUrl: './purchase-reservation-tg.component.html',
  styleUrl: './purchase-reservation-tg.component.scss',
  standalone: true,
})
export class PurchaseReservationTgComponent implements OnInit {
  constructor(
    private agendaReservaService: ReservationScheduleService,
    private dialog: MatDialog,
  ) {}

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  searchForm: any = { search: false, model: {} }

  columns: any[] = [
    {
      keyColumn: 'tg_info',
      key: 'tg_info',
      description: 'TG / Evento',
    },
    {
      keyColumn: 'client_info',
      key: 'client_info',
      description: 'Cliente',
    },
    {
      keyColumn: 'event_period',
      key: 'event_period',
      description: 'Período',
    },
    {
      keyColumn: 'os_pendentes',
      key: 'os_pendentes',
      description: 'OS Pendentes',
    },
    {
      keyColumn: 'totais',
      key: 'totais',
      description: 'Compras',
    },
    {
      keyColumn: 'action',
      key: { view: true },
      description: 'Ações',
    },
  ]

  ngOnInit() {
    this.getListItems()
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({ ...item })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.agendaReservaService.listPagedTg(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: any) => {},
      complete: () => {
        this.loading = false
      },
    })
  }

  searchListItems() {
    this.loading = true
    const model: SearchReservationTgModel = {
      ...new SearchReservationTgModel(),
      ...this.searchForm.model,
    }
    this.agendaReservaService
      .searchPagedTg(this.page, this.rows, model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: any) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  search(event: any) {
    this.page = 1
    this.searchForm = event
    if (event.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  uploadList() {
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  viewItem(item: any) {
    this.dialog.open(PurchaseReservationTgViewComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: item,
    })
  }
}
